import React, { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface AdminPageProps {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}

const AdminPage = ({ title, description, action, children }: AdminPageProps) => {
  return (
    <Stack spacing={3}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Box>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body1" color="text.secondary">
              {description}
            </Typography>
          ) : null}
        </Box>
        {action}
      </Box>
      {children}
    </Stack>
  );
};

export default AdminPage;
